module.exports = __webpack_public_path__ + "media/images/features/modification/heading-voices-1fad1df2bb5fdd49a36859ca66474801.svg";